var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0499 15.7701C18.0499 20.7977 14.0093 24.8734 9.02511 24.8734C4.04097 24.8734 0 20.7968 0 15.7701C0 10.7434 4.04067 6.6665 9.02511 6.6665C14.0096 6.6665 18.0499 10.7425 18.0499 15.7701Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9504 15.77C27.9504 20.5025 25.9301 24.3404 23.4379 24.3404C20.9456 24.3404 18.9253 20.5025 18.9253 15.77C18.9253 11.0376 20.9453 7.19971 23.4375 7.19971C25.9298 7.19971 27.9501 11.0364 27.9501 15.77",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15.7704C32 20.0095 31.2896 23.4481 30.4129 23.4481C29.5363 23.4481 28.8262 20.0105 28.8262 15.7704C28.8262 11.5304 29.5366 8.09277 30.4129 8.09277C31.2893 8.09277 32 11.5301 32 15.7704Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMedium);
export default __webpack_public_path__ + "static/media/ic-medium.eaef387e9fdd9f0f96bb9ea2347b708a.svg";
export { ForwardRef as ReactComponent };